// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"2a69ef52","356":"79f7ede6","420":"2c5a515a","620":"1f41737b"}[chunkId] + ".chunk.js";
};